export function readWorkingRevision(state: Record<string, unknown>): number {
  const value = (state as { workingRevision?: unknown }).workingRevision;
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

export function readPersistedRevision(state: Record<string, unknown>): number {
  const value = (state as { persistedRevision?: unknown }).persistedRevision;
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

export function bindRevisionFields(state: Record<string, unknown>): {
  workingRevision: number;
  persistedRevision: number;
} {
  return {
    workingRevision: readWorkingRevision(state),
    persistedRevision: readPersistedRevision(state),
  };
}
